import { jsx as _jsx } from "react/jsx-runtime";
import { useState, createContext, useEffect } from "react";
import { getSharedUiHeaderBffData } from "../utils/api";
export const SharedUiHeaderV2Context = /*#__PURE__*/ createContext({});
export const SharedUiHeaderV2Provider = ({ children , stageName , isLoggedIn , accessToken , firstName , email , favourites , activeOrder , handleTrackEvent , refreshActiveOrder , setIsCheckoutModalVisible , isCheckoutModalVisible , isGapMenuItemShown , isUpdatedCinchCareCopy  })=>{
    const [userStore, setUserStore] = useState({
        stageName,
        isLoggedIn,
        accessToken,
        firstName,
        email,
        favourites,
        activeOrder,
        refreshActiveOrder
    });
    const [logicStore, setLogicStore] = useState({
        handleTrackEvent: handleTrackEvent,
        setIsCheckoutModalVisible,
        isCheckoutModalVisible: isCheckoutModalVisible,
        searchData: null
    });
    useEffect(()=>{
        setLogicStore({
            handleTrackEvent: handleTrackEvent,
            setIsCheckoutModalVisible: setIsCheckoutModalVisible,
            isCheckoutModalVisible: isCheckoutModalVisible,
            searchData: null
        });
        setUserStore({
            stageName,
            isLoggedIn,
            accessToken,
            firstName,
            email,
            favourites,
            activeOrder,
            refreshActiveOrder
        });
    }, [
        stageName,
        isLoggedIn,
        accessToken,
        firstName,
        favourites,
        activeOrder,
        refreshActiveOrder,
        setIsCheckoutModalVisible,
        isCheckoutModalVisible
    ]);
    useEffect(()=>{
        const getSearchData = async ()=>{
            const searchData = await getSharedUiHeaderBffData();
            if (// eslint-disable-next-line no-prototype-builtins
            (searchData === null || searchData === void 0 ? void 0 : searchData.hasOwnProperty("find-a-car")) && // eslint-disable-next-line no-prototype-builtins
            (searchData === null || searchData === void 0 ? void 0 : searchData["find-a-car"].hasOwnProperty("popular-makes"))) {
                const findACarSearchData = searchData["find-a-car"];
                const popularMakes = findACarSearchData["popular-makes"];
                setLogicStore({
                    ...logicStore,
                    searchData: popularMakes
                });
            }
        };
        if (logicStore.searchData === null) {
            getSearchData();
        }
    }, [
        logicStore.searchData
    ]);
    return /*#__PURE__*/ _jsx(SharedUiHeaderV2Context.Provider, {
        value: {
            userStore,
            setUserStore,
            logicStore,
            setLogicStore,
            isGapMenuItemShown,
            isUpdatedCinchCareCopy
        },
        children: children
    });
};
